import { SessionConstants as Constants } from '../types'

const initialState = {
    sessions: [],    
    error: null,    
    active: null,
    loading: false   
};

export function sessionReducer(state = initialState, action) {
    switch (action.type) {  

        case Constants.GET:                     
            return {
                ...state,
                sessions: action?.payload?.sessions,
                loading: false,
                error: null,
            };

        case Constants.ACTIVE:                     
            return {
                ...state,
                active: action?.payload?.session,
                loading: false,
                error: null,
            };

   
            
        case Constants.ADD:
            return {
                ...state,
                sessions: [...state?.sessions, action?.payload?.session],
                loading: false,
                error: null,
            }

        case Constants.UPDATE:            
            const index = state.sessions.findIndex(x => x.id ===  action?.payload?.session?.id)
            const newArray = [...state.sessions];
            if(index > -1)
                newArray[index] = action?.payload?.session
            return {
                ...state,
                sessions: newArray,
                loading: false,
                error: null,
            }   

        case Constants.DELETE:
            return{
                ...state,
                sessions: state?.sessions?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id)),
                loading: false,
                error: null,
            };

        
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error,
                loading: false
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null,
                loading: true
            }

        case Constants.CLEAR:
        default:
            return state
    }
}